export const OrganisationType = Object.freeze({
    EXPORTER: 1,
    REGISTERED_ESTABLISHMENT: 2,
    RE_EXPORTER: 3
})